import config from '../config'
import {launchParams} from '../launchParams'

export const findOrCreateQuizSession = (
  assignmentId,
  windowObj = window,
  getLaunchParams = launchParams,
) => {
  const {accessToken} = getLaunchParams(windowObj.location.search, windowObj.sessionStorage)

  // eslint-disable-next-line no-param-reassign, immutable/no-mutation
  windowObj.location = `/easy_auth/take_quiz?token=${accessToken}&assignment_id=${assignmentId}`
}
export const createNewQuiz = (windowObj = window, getLaunchParams = launchParams) => {
  const {accessToken} = getLaunchParams(windowObj.location.search, windowObj.sessionStorage)

  // eslint-disable-next-line no-param-reassign, immutable/no-mutation
  windowObj.location = `/easy_auth/new_quiz?token=${accessToken}`
}

/**
 * Enable MSW (Mock Service Worker) for API mocking in the browser.
 * Sets a flag in sessionStorage to enable MSW on next page load.
 * The page will automatically reload to apply the changes.
 *
 * Usage: In browser console, call `enableMSW()` to start mocking requests.
 *
 * @returns {void}
 */
export function enableMSW() {
  if (typeof window === 'undefined') {
    console.warn('MSW can only be enabled in browser environment')
    return
  }

  try {
    window.sessionStorage.setItem('__msw_enabled', 'true')
    /* eslint-disable no-console */
    console.log('MSW will be enabled on page refresh.')
    console.log('Reloading page...')
    /* eslint-enable no-console */
    window.location.reload()
  } catch (storageError) {
    console.error('Failed to enable MSW:', storageError)
  }
}

/**
 * Disable MSW (Mock Service Worker) for API mocking in the browser.
 * Clears the flag from sessionStorage and reloads the page.
 *
 * Usage: In browser console, call `disableMSW()` to stop mocking requests.
 *
 * @returns {void}
 */
export function disableMSW() {
  if (typeof window === 'undefined') {
    console.warn('MSW can only be disabled in browser environment')
    return
  }

  try {
    window.sessionStorage.removeItem('__msw_enabled')
    /* eslint-disable no-console */
    console.log('MSW will be disabled on page refresh.')
    console.log('Reloading page...')
    /* eslint-enable no-console */
    window.location.reload()
  } catch (storageError) {
    console.error('Failed to disable MSW:', storageError)
  }
}

export function setUpDevHelpers(windowObj = window, configuration = config) {
  if (configuration.inDevelopment()) {
    /* eslint-disable no-param-reassign, immutable/no-mutation */
    windowObj.findOrCreateQuizSession = findOrCreateQuizSession
    windowObj.createNewQuiz = createNewQuiz
    windowObj.enableMSW = enableMSW
    windowObj.disableMSW = disableMSW
    /* eslint-enable no-param-reassign, immutable/no-mutation */
  }
}

export default setUpDevHelpers
